import 'components/interstitial/interstitical.scss';
import { displayShowWhenHideWhenLabel } from 'layout/utils-show-hide.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { IBaseAdConfig } from 'redux-state/advertisement/types.js';
import { InterstitialPortalAddRemoveModalFromInterstitialContainer } from './interstitial-portal-add-remove-el-from-modal.js';
import { InterstitialAdvert } from './interstitial.js';

/**
 * Interstitial Display Component
 * Treat with care as it is VERY important that this only renders the portal once.
 * We do not want to crreate
 */
const InterstitialPortalCore = ({
  interstitialPayload,
}: {
  interstitialPayload?: IBaseAdConfig;
}): JSX.Element | null => {
  const columnLayout = React.useContext(ColumnLayoutContext);

  const displayInterstitial = displayShowWhenHideWhenLabel(interstitialPayload?.layout, columnLayout);

  /** Firefox v102 in strict protection settings causes false positives with ads. This causes a black screen making the site unusable */
  const isFirefox102 = navigator.userAgent.includes('Firefox/102');

  /**
   * Add Removes Interstitial Container From Modal on mount / unmount
   * Attached property allows us to unmount the component and remount when changing pages
   */
  const { interstitialContainerEl } = InterstitialPortalAddRemoveModalFromInterstitialContainer({
    displayOncePerSession: false,
  });

  if (displayInterstitial && interstitialPayload && !isFirefox102 && interstitialContainerEl.current) {
    /** We have already updated the interstitial target data so we do not want to override so we use overrideBaseTargeting={true} */
    return ReactDOM.createPortal(
      <InterstitialAdvert
        fuseTag={interstitialPayload.fuseTag}
        adUnitPath={interstitialPayload.adUnitPath}
        targeting={interstitialPayload.targeting}
      />,
      interstitialContainerEl.current,
    );
  }

  return null;
};

export const InterstitialPortal = React.memo(InterstitialPortalCore);
